import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getCategoryDiagnosisCodes } from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";

const DialCodeMapping = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const userData = useUserData();
  const practiceId = userData?.selected_practice;
  const token = userData?.access_token;

  useEffect(() => {
    fetchDiagCode();
  }, []);

  const fetchDiagCode = async () => {
    setData([]);
    try {
      const payload = {
        practice_id: practiceId,
      };
      const res = await getCategoryDiagnosisCodes(payload, token);
      if (res) {
        setData(res);
      }
    } catch (error) {
      console.error("Error fetching HCC Categories:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box
        padding={4}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      {data.map((item, index) => (
        <Accordion key={index} defaultExpanded={index === 0}>
          <AccordionSummary
            sx={{ backgroundColor: "rgba(203, 51, 102, 0.1)" }}
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography fontWeight={600}>
              {item.hcc_category} ({item.hcc_category_definition})
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box
              sx={{
                maxHeight: 250,
                overflowY: "auto",
                border: "1px solid #eee",
                borderRadius: 1,
                p: 1,
              }}
            >
              <List dense>
                {item.hcc_diagnosis_codes.map((code, i) => (
                  <ListItem key={i} sx={{ whiteSpace: "normal" }}>
                    <Typography variant="body2">{code}</Typography>
                  </ListItem>
                ))}
              </List>
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default DialCodeMapping;
